import { render } from "./PlotOrderTemplateEditWidget.vue?vue&type=template&id=297b4089&ts=true"
import script from "./PlotOrderTemplateEditWidget.ts?vue&type=script&lang=ts&external"
export * from "./PlotOrderTemplateEditWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__